module.exports = __webpack_public_path__ + "static/bi-folds_&_side_screens-d041b4d3037e8eb01b48695ec7e8557f.jpg";